import { range } from 'lodash'

import { ExecuteCommandPayload, MutationType, ObjectDataRecord } from '@types'

interface ListQueryResponse<T> {
  data: T[]
  totalCount: number
}

type GetAllPagesDataType = {
  firstPageData: ListQueryResponse<ObjectDataRecord>
  executeCommand: MutationType<ExecuteCommandPayload, unknown>
  commandParams: ExecuteCommandPayload
}

/**
 * Загружает все страницы данных с пагинацией
 */
export const getAllPagesDataForMap = (props: GetAllPagesDataType) => {
  const { firstPageData, executeCommand, commandParams } = props
  const { data, totalCount } = firstPageData

  return totalCount <= 1
    ? Promise.resolve(data)
    : (async () => {
        const requests = range(1, totalCount).map(page =>
          executeCommand({
            ...commandParams,
            params: { ...commandParams.params, page },
          }).unwrap()
        )

        const results = await Promise.all(requests)
        const otherPages = results as ListQueryResponse<ObjectDataRecord>[]
        const otherPagesData = otherPages.map(item => item.data).flat(1)

        return [...data, ...otherPagesData]
      })()
}
